import dayjs from 'dayjs'

export const FORMATTED_TOMORROW_DATE: string = dayjs().add(1, 'day').format('YYYY-MM-DD')
export const FORMATTED_TODAY_DATE: string = dayjs().format('YYYY-MM-DD')
